import Tags from './Tags'
import PropTypes from 'prop-types'
import {
  CheckHistoryOutlined,
  CheckDoubleOutlined,
  XCircleSolid,
  ClockSolid,
} from '@/assets/svgs/status'

export const STATUS = {
  DRAFT: 'DRAFT',
  PENDING_REVIEW: 'PENDING_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REPLACED: 'REPLACED',
  DELETED: 'DELETED',
  PASSED_DEADLINE: 'PASSED_DEADLINE',
}

const NEUTRAL = 'bg-grey-95 text-grey-50 [&_svg_path]:fill-grey-50'
const WARNING = 'bg-yellow-95 text-yellow-50 [&_svg_path]:fill-yellow-50'
const SUCCESS = 'bg-green-95 text-green-50 [&_svg_path]:fill-green-50'
const CRITICAL = 'bg-red-95 text-red-50 [&_svg_path]:fill-red-50'

const statusTagProperties = {
  [STATUS.DRAFT]: {
    label: 'Draft',
    prefixIcon: <CheckHistoryOutlined />,
    tagClassName: NEUTRAL,
  },
  [STATUS.PENDING_REVIEW]: {
    label: 'Pending Review',
    prefixIcon: <CheckHistoryOutlined />,
    tagClassName: WARNING,
  },
  [STATUS.APPROVED]: {
    label: 'Approved',
    prefixIcon: <CheckDoubleOutlined />,
    tagClassName: SUCCESS,
  },
  [STATUS.REJECTED]: {
    label: 'Rejected',
    prefixIcon: <XCircleSolid />,
    tagClassName: CRITICAL,
  },
  [STATUS.REPLACED]: {
    label: 'Replaced',
    prefixIcon: <XCircleSolid />,
    tagClassName: NEUTRAL,
  },
  [STATUS.DELETED]: {
    label: 'Deleted',
    prefixIcon: <ClockSolid />,
    tagClassName: NEUTRAL,
  },
  [STATUS.PASSED_DEADLINE]: {
    label: 'Passed Deadline',
    prefixIcon: <ClockSolid />,
    tagClassName: CRITICAL,
  },
}

const StatusTags = ({ status }) => {
  return <Tags dataTestId={'status-tag'} {...statusTagProperties[status]} />
}

StatusTags.propTypes = {
  status: PropTypes.string,
}

export default StatusTags
